module.exports = __webpack_public_path__ + "static/media/Neo-Bank-App-04.5f199acc.png";